export interface OperatingRoomBarRow {
  key: string
  label: string
  /** Largo de la barra, de 0 a 1 (la parte del total o el % de ocupación; pasado de 1, se recorta). */
  fraction: number
  /** El valor escrito: «12 de 40» o «27,0 %». La barra es un adorno del valor, que siempre va escrito. */
  valueText: string
}

interface OperatingRoomBarsProps {
  rows: OperatingRoomBarRow[]
  /** Id del título de la sección, que nombra la lista. */
  ariaLabelledBy: string
}

/**
 * Un reparto como filas con barra: el nombre, una barra proporcional y el valor escrito (la barra es un adorno, no la única
 * forma de leer el dato). Sin filas no dibuja nada.
 * TODO(design-system): gráficos. Novarium no define las barras horizontales.
 */
export default function OperatingRoomBars({ rows, ariaLabelledBy }: OperatingRoomBarsProps) {
  if (rows.length === 0) return null
  return (
    <ul className="nv-or-bars" aria-labelledby={ariaLabelledBy}>
      {rows.map((row) => (
        <li key={row.key} className="nv-or-bar">
          <span className="nv-or-bar__name">{row.label}</span>
          <span className="nv-or-bar__track" aria-hidden="true">
            <span className="nv-or-bar__fill" style={{ width: `${Math.max(0, Math.min(row.fraction, 1)) * 100}%` }} />
          </span>
          <span className="nv-or-bar__value">{row.valueText}</span>
        </li>
      ))}
    </ul>
  )
}
